import cx from 'classnames';

import Tooltip from '../Tooltip';
import type { TooltipProps } from '../Tooltip';

import IconBadge from './IconBadge';
import type { IconBadgeProps } from './IconBadge';

type Props = Omit<TooltipProps, 'children'> & IconBadgeProps;

/**
 * An IconBadge wrapped in a Tooltip component.
 */
const TooltipIconBadge = ({
  tooltip,
  placement = 'top',
  showTooltip,
  id,
  ...iconBadgeProps
}: Props) =>
  <Tooltip
    id={id}
    tooltip={tooltip}
    placement={placement}
    showTooltip={showTooltip}
  >
    {/* Tooltip requires its child to be inline-block  */}
    <div className={cx('inline-block')}>
      <IconBadge
        {...iconBadgeProps}
      />
    </div>
  </Tooltip>;

export default TooltipIconBadge;
